exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Separator {\n  width: 2px;\n  height: 15px;\n  background-color: #bfbfbf;\n  display: inline-block;\n  margin: 0 5px; }\n", ""]);

// exports
